import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ErrorOutline } from "@mui/icons-material";

import { useAudienceUtils } from "@/hooks";
import { Audience } from "@/types";

interface DeleteAudienceDialogProps {
  audience: Audience;
  open: boolean;
  onClose: () => void;
  redirect?: string;
}

const DeleteAudienceDialog: React.FC<DeleteAudienceDialogProps> = ({
  audience,
  open,
  onClose,
  redirect,
}) => {
  const theme = useTheme();
  const { utils, action } = useAudienceUtils(audience.audience_id, audience);

  return (
    <Dialog open={open} disableEnforceFocus aria-labelledby="delete-dialog">
      <DialogTitle sx={{ background: theme.palette.error.dark }}>
        <Box display="flex" flexDirection="row" alignItems="center">
          <ErrorOutline sx={{ mr: 1 }} />
          <Typography variant="body1">
            Are you sure you want to delete this audience?
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <Typography>
          Please confirm you wish to delete <b>{audience.audience_name}</b> from
          your saved audiences.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={() => utils.handleDelete(redirect)}
          loading={action.status === 'loading' && action.type === 'delete'}
        >
          Delete Audience
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAudienceDialog;
